import { Component, OnInit, ViewChild,ElementRef} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { GlobalServices } from 'src/app/shared/services/global.service';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from 'src/app/front-user/shared/services/authentication.service';
import { AlertService } from 'src/app/shared/components/alert/alert.service';
import { BaseRequestService } from 'src/app/front-user/shipyard-service/services/base-request.service';
import { FormMode, Languages, ServiceStatus } from 'src/app/shared/models/enums.model';
import { BaseRequest } from 'src/app/shared/models/base-request.model';
import { first } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { User } from 'src/app/front-user/shared/models/user.model';
import { ResponseObject } from 'src/app/shared/models/response-object.model';
import { GenericLookup } from 'src/app/front-user/shared/models/generic-lookup.model';
import { LookupService } from 'src/app/front-user/shared/services/lookup.service';
import { TransitAdminService } from '../../shared/services/transit-admin.service';
import { TransitAdminDto,TransitAccurateDataDto } from '../../shared/models/transit-admin.model';
import { CustomValidators } from 'src/app/front-user/shipyard-service/models/custom-validator';
import { DatePipe } from '@angular/common';
import { TransitRequestComponent } from 'src/app/front-user/services/e-booking/transit-request/transit-request.component';
import { TransitService } from 'src/app/front-user/services/e-booking/transit-request/transit-request.service';

@Component({
  selector: 'app-ebooking-Accuarte-Data',
  templateUrl: './ebooking-Accuarte-Data.component.html',
})
export class EbookingAccurateDataComponent implements OnInit {

  @ViewChild('transitRequest',{static: false}) transitRequest: TransitRequestComponent;
  @ViewChild ('accurateDataFormControls',{static: false}) accurateDataFormControls: ElementRef;
  public FormMode: any = FormMode;
  public formMode: any = FormMode.Add;
  public submitConfirmationMode: ConfirmationMode = ConfirmationMode.Success;
  displayedLang: Languages;

  private submitAccurateDataFormResponseObject: ResponseObject = new ResponseObject();
  private submitAccurateDataFormObject;
  private getAccurateDataFormResponseObject: ResponseObject = new ResponseObject();
  private getAccurateDataFormObject: TransitAccurateDataDto;

  responseObj: ResponseObject = new ResponseObject();
  showRequest: boolean = false;
  securityLevels: GenericLookup[] = [];
  baseRequestId: string = '';
  requestStatus: number;
  private accurateDataForm: FormGroup;
  baseRequestDTO: BaseRequest// = new BaseRequest();
  user: User = new User();
  public isRequestSucceeded: boolean = false;


  constructor(private formBuilder: FormBuilder, private baseRequestService: BaseRequestService,
    private globalSrv: GlobalServices,
    private transitSrv: TransitService,
    private lookupService: LookupService,
    private toastr: ToastrService,
    private datePipe: DatePipe,
    private route: ActivatedRoute, private router: Router,
    private translate: TranslateService, private adminSrv: TransitAdminService,
    private authenticationService: AuthenticationService, private alertService: AlertService) {
    this.displayedLang = this.globalSrv.getLanguage()
    if (history.state.data && history.state.data.requestId) {
      this.baseRequestId = history.state.data.requestId;
    }
    else{
      window.history.back();
    }
    this.user = this.globalSrv.user;
  }
  ngOnInit() {
    this.globalSrv.isLoaderEnabled = true;
    if (this.baseRequestId) {
      this.GetTransitAccurateData();
    }
    this.buildForm();
  }
  buildForm(): void {
    this.accurateDataForm = this.formBuilder.group({
      Accurate_DFWD: ['', [ Validators.maxLength(150)]],
      Accurate_DAFT: ['', [ Validators.maxLength(150)]],
      Accurate_AirDraught: ['', [ Validators.maxLength(150)]],
      Accurate_Anchor: ['', []],
      Accurate_Cranes: ['', []],
      Accurate_RegisterCertificateExpireDate: ['', [ CustomValidators.dateValidator()]],
      Accurate_Securitylevel: ['', Validators.required],
      Accurate_PropellerTypes: ['', []],
      Accurate_Extensions: ['', []],
      Accurate_FloatingUnits: ['', []],
      Accurate_MaxSpeed: ['', [ Validators.maxLength(150)]],
      Accurate_MinSpeed: ['', [ Validators.maxLength(150)]],
      Accurate_Note:['']
    })
  }
  getLookupsWithDeleted() {
    this.lookupService.GetSecurityLevel()
      .subscribe((data: ResponseObject) => {
        this.securityLevels = data.Data as GenericLookup[];
      });
    /*this.lookupService.GetNationality().subscribe(d => {
      this.nationalities = d.Data.filter(p => p.IsDeleted == false) as GenericLookup[];
    });*/

  }
  get f() {
    return this.accurateDataForm.controls;
  }
  getBaseRequest() {
    this.baseRequestService.getBaseRequest(this.baseRequestId).subscribe(
      d => {
        this.baseRequestDTO = d.Data;
        this.requestStatus = this.baseRequestDTO.StatusId;
        if (this.requestStatus == ServiceStatus.PendingOnDocumentConfirmation) {
          this.formMode = FormMode.Add;

        }
        else if (history.state.data && history.state.data.isCompleted) {

          this.formMode = FormMode.Readonly;
        }
        else {

          this.formMode = FormMode.Readonly;
        }
        this.toastr.success('New Accurate Data!', 'Success!');
        this.globalSrv.isLoaderEnabled = false;
        window.scrollTo(0, 1100);

      }
    )
  }
  public getTransitRequest() {
    this.transitSrv.get(this.baseRequestId).pipe(first()).subscribe(
      (resObj: ResponseObject) => {
        this.getLookupsWithDeleted();
        this.responseObj = resObj;
        if (this.responseObj.Success) {
         //this.formMode = FormMode.Readonly;
          //this.accurateDataForm.patchValue(resObj.Data);

          this.accurateDataForm.patchValue({
            Accurate_DFWD:resObj.Data['D_FWD'],
            Accurate_DAFT:resObj.Data['D_AFT'],
            Accurate_AirDraught:resObj.Data['AirDraught'],
            Accurate_PropellerTypes:resObj.Data['PropellerType'],
            Accurate_Cranes:resObj.Data['ShipsCranes'],
            Accurate_Anchor:resObj.Data['Anchors'],
            Accurate_MaxSpeed:resObj.Data['MaxManouveringSpeed'],
            Accurate_Extensions:resObj.Data['Extensions'],
            Accurate_Securitylevel:resObj.Data['SecurityLevelId'],
            Accurate_FloatingUnits:resObj.Data['FloatingUnits'],
            Accurate_RegisterCertificateExpireDate:resObj.Data['RegisteryCertificateDate'],
          });
          //--------------------------------------
          this.getBaseRequest();
        }
      });
  }
  later(): void {
    this.router.navigateByUrl('/workspace');
  }
  submit(): void {
    const inValidControls = this.accurateDataFormControls.nativeElement.querySelectorAll('.ng-invalid');
    if(inValidControls.length > 0) {
      inValidControls[0].focus();
    } else {
      this.globalSrv.isLoaderEnabled = true;
      this.submitAccurateDataFormObject = this.accurateDataForm.value as TransitAccurateDataDto;
      this.submitAccurateDataFormObject.RequestId = this.baseRequestId;
      this.submitAccurateDataFormObject.Accurate_RegisterCertificateExpireDate = this.datePipe.transform(this.accurateDataForm.controls.Accurate_RegisterCertificateExpireDate.value, "yyyy-MM-dd");
       this.submitAccurateDataForm();

    }
  }
  GetTransitAccurateData(): void{
    this.transitSrv.GetTransitAccurateData(this.baseRequestId).subscribe(
      data => this.getAccurateDataFormResponseObject = data,
      () => console.log("Something went wrong!!"),
      () => this.GetTransitAccurateDataCompleted()
    );
  }
  GetTransitAccurateDataCompleted(): void {
    if(this.getAccurateDataFormResponseObject.Success) {
      this.getLookupsWithDeleted();
      this.getAccurateDataFormObject = this.getAccurateDataFormResponseObject.Data as TransitAccurateDataDto;
      if(this.getAccurateDataFormObject != null){
           this.accurateDataForm.patchValue({
             Accurate_DFWD:this.getAccurateDataFormObject.Accurate_DFWD,
             Accurate_DAFT:this.getAccurateDataFormObject.Accurate_DAFT,
             Accurate_AirDraught:this.getAccurateDataFormObject.Accurate_AirDraught,
             Accurate_PropellerTypes:this.getAccurateDataFormObject.Accurate_PropellerTypes,
             Accurate_Cranes:this.getAccurateDataFormObject.Accurate_Cranes,
             Accurate_Anchor:this.getAccurateDataFormObject.Accurate_Anchor,
             Accurate_MaxSpeed:this.getAccurateDataFormObject.Accurate_MaxSpeed,
             Accurate_MinSpeed:this.getAccurateDataFormObject.Accurate_MinSpeed,
             Accurate_Extensions:this.getAccurateDataFormObject.Accurate_Extensions,
             Accurate_Securitylevel:this.getAccurateDataFormObject.Accurate_Securitylevel,
             Accurate_FloatingUnits:this.getAccurateDataFormObject.Accurate_FloatingUnits,
             Accurate_RegisterCertificateExpireDate:this.getAccurateDataFormObject.Accurate_RegisterCertificateExpireDate,
             Accurate_Note:this.getAccurateDataFormObject.Accurate_Note,
           });
           window.scrollTo(0, 1100);
           this.toastr.success('Accurate Data', 'Success!');

      }
      else{
        this.getTransitRequest();
      }
      const el = document.getElementsByClassName('sectionTitle');
      el[0].scrollIntoView({behavior:'smooth'});
    } else {
      //Enable Error
      this.submitConfirmationMode = ConfirmationMode.Error;
      this.isRequestSucceeded = true;
    }
    //Disable Loader
    this.globalSrv.isLoaderEnabled = false;
  }
  submitAccurateDataForm(): void {
    this.transitSrv.AddTransitAccurateData(this.submitAccurateDataFormObject).subscribe(
      data => this.submitAccurateDataFormResponseObject = data,
      () => console.log("Something went wrong!!"),
      () => this.submitAccurateDataFormCompleted()
    );
  }
  submitAccurateDataFormCompleted(): void {
    if(!this.submitAccurateDataFormResponseObject.Success) {
      //Enable Error
      this.submitConfirmationMode = ConfirmationMode.Error;
    }
    this.isRequestSucceeded = true;
    //Disable Loader
    this.globalSrv.isLoaderEnabled = false;

    this.toastr.success('Data Saved Successfully', 'Success!');
  }
}


enum ConfirmationMode {
  Success  = 1,
  Error = 2
}
